export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
            <i className="ri-mail-send-line text-2xl text-primary-600"></i>
          </div>
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-3">
            期待你的声音
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto">
            如果你有影视资源推荐、内容合作意向或任何意见反馈，欢迎随时与我们取得联系。
            玫瑰视频期待与更多优质平台携手合作，为追剧爱好者带来更丰富的观影选择。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer">
              <i className="ri-mail-line"></i>
              发送邮件
            </span>
            <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-foreground-700 text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer">
              <i className="ri-chat-3-line"></i>
              在线留言
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}